import { StrapiImage, StrapiImageProps } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

import { RatingsStars } from "./RatingsStars";

type RatingsMarkProps = {
  image: StrapiImageProps["image"];
  rating: string;
  source: string;
};

export const RatingsMark = ({ image, rating, source }: RatingsMarkProps) => {
  const i18n = useI18n();

  return (
    <div className="flex flex-col items-center">
      <div className="overflow-y-hidden">
        <div className="-mb-[180px] w-[280px] h-[280px] ">
          <StrapiImage image={image} size="small" />
        </div>
      </div>

      <section
        className="flex z-10 flex-col items-center p-4 px-12 w-fit text-center bg-white rounded-lg"
        style={{
          boxShadow:
            "21.06px 14.74px 42.12px 0px #00000014, -4.21px -2.11px 16.85px 0px #00000014",
        }}
      >
        <p className="font-bold lg:text-lg">
          {i18n.t("product.seo.ratings.mark")}
        </p>
        <RatingsStars rating={rating} />
        <p className="text-[12px] font-light text-[#00000066]">
          {i18n.t("product.seo.ratings.source", { source })}
        </p>
      </section>
    </div>
  );
};
